import { SelectedOption } from "src/types/storefront";

export default function getOptionValueByName(
	optionName: string,
	options: SelectedOption[]
) {
	const option = options.find(({ name }) => optionName === name);
	return option ? option.value : null;
}
